import React from "react";

import { AxisLeft, AxisRight } from "@visx/axis";
import { Text } from "@visx/text";

import type { SideAxisProps } from "./types";

const getCondensedNotation = (numberOfZeros: number) => {
  if (numberOfZeros >= 12) {
    return "T";
  }

  if (numberOfZeros >= 9) {
    return "B";
  }

  if (numberOfZeros >= 6) {
    return "M";
  }

  if (numberOfZeros >= 3) {
    return "K";
  }

  return "";
};

const SideAxis = ({
  axis,
  top,
  left,
  numberOfTicks,
  scale,
  variant = "left",
}: SideAxisProps) => {
  const commonProps = {
    label: axis.label,
    scale,
    top,
    left,
    labelOffset: 40,
    numTicks: numberOfTicks,
    stroke: "transparent",
    tickStroke: "transparent",
    labelProps: {
      fontSize: 10,
      textAnchor: "middle" as const,
    },
    tickComponent: ({ formattedValue, ...rest }: any) => {
      const indexOfFirstComma = formattedValue.indexOf(",");

      let num = formattedValue;

      if (indexOfFirstComma > -1) {
        num = formattedValue.slice(0, indexOfFirstComma);
      }

      const numberOfZeros = formattedValue
        .slice(indexOfFirstComma)
        .replaceAll(",", "").length;

      return (
        <Text
          {...rest}
          fontSize={10}
        >
          {`${num}${getCondensedNotation(numberOfZeros)}`}
        </Text>
      );
    },
  };

  return (
    <>
      {variant === "left" ? (
        <AxisLeft {...commonProps} />
      ) : (
        <AxisRight {...commonProps} />
      )}
    </>
  );
};

export default SideAxis;
